module.exports = __webpack_public_path__ + "img/23.61c99dd1.jpg";